class ICoreMarqueeScroller {
    elementId = null;
    marqueeContainer = null;

    constructor(elementId) {
        this.elementId = elementId;
        this.marqueeInstance = null;

        this.init();
    }

    init() {
        this.marqueeContainer = document.getElementById(this.elementId);
        if ( !this.marqueeContainer ) {
            return new Error('No marquee container element found');
        }

        if ( window.matchMedia("(prefers-reduced-motion: reduce)").matches ) {
            if( this.marqueeContainer.classList.contains('izzycart-marquee-scroller--fadeEdges') ) {
                this.marqueeContainer.classList.remove('izzycart-marquee-scroller--fadeEdges');
            }
            return;
        }

        this.addAnimation();
    }

    addAnimation = () => {
        this.marqueeContainer.setAttribute('data-animated', true);
        const scrollerInner = this.marqueeContainer.querySelector('.izzycart-marquee-scroller__inner');
        const scrollerInnerChildren = Array.from(scrollerInner.children);

        scrollerInnerChildren.forEach(item => {
            const dupItem = item.cloneNode(true);
            dupItem.setAttribute('aria-hidden', true);
            scrollerInner.appendChild(dupItem);
        });
    }

    // Not used currently but can be useful for future features
    addHoverEvents = () => {
        this.marqueeContainer.addEventListener('mouseenter', this.pauseAnimation);
        this.marqueeContainer.addEventListener('mouseleave', this.resumeAnimation);
    }
}

export default ICoreMarqueeScroller;